import React, { useEffect } from "react";
import { Col, Container, Form, Row, Tab, Tabs } from "react-bootstrap";
import style from "../form.module.scss";
import { useKPIs } from "../../../context/KPIsContext";
import { TODIS_FORM_FIELD } from "../../../components/Forms";
import "react-datepicker/dist/react-datepicker.css";
import { BsArrowClockwise } from "react-icons/bs";
import { TODIS_BTN_SECUNDARY } from "../../../components/Buttons";

const ROADS_IMP_PM_KPI = ({data, changeValues, filter, showModalCalRange}) => {

    const { setValues, values, calculoPeriod, calculoDias } = useKPIs();

    useEffect(() => {
        setValues(prev => {
            return data
        })
    }, [data])

    useEffect(() => {
        calculateKPI()
    }, [values])

    const calculateKPI = () => {
       
        const datas = {
            performanceInd : {
                projectTimelineDeviation : {
                    init_proj_comp_date: calculoDias('actual_proj_comp_date', 'init_proj_comp_date', null, filter.yearInit),
                    const_period: calculoPeriod('actual_const_period', 'forecast_const_period', filter.yearInit)
                },
                capex: calculoPeriod('actual_capex', 'forecast_capex', filter.yearInit), 
                opex: calculoPeriod('actual_opex', 'forecast_opex', filter.yearInit),
                maintenance: calculoPeriod('actual_maint_cost', 'forecast_maint_cost', filter.yearInit),
                ebitda: calculoPeriod('actual_ebitda','forecast_ebitda', filter.yearInit),
                revenue: calculoPeriod('actual_revenue', 'forecast_revenue', filter.yearInit),
                traffic_dev: {
                    total: calculoPeriod('actual_total', 'forecast_total', filter.yearInit),
                    pass_cars: calculoPeriod('actual_pass_cars', 'forecast_pass_cars', filter.yearInit),
                    busses: calculoPeriod('actual_busses', 'forecast_busses', filter.yearInit),
                    hgv: calculoPeriod('actual_trucks', 'forecast_trucks', filter.yearInit)
                }
            }
        }

        changeValues(datas)
    }

    return (
        <Tabs defaultActiveKey="performanceInd" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">
            <Tab eventKey="performanceInd" title="Performance Indicators" className={style.tabHeight} style={{height: "71vh"}}>
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div style={{borderBottom: "3px solid #004494"}}>
                                <Form.Label style={{color: '#004494', fontSize: "16px", fontWeight: "bold"}}>Project Timeline Deviation</Form.Label>
                            </div>
                            <Row style={{paddingTop: "15px"}}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="performanceInd.projectTimelineDeviation.init_proj_comp_date" label="Completion date deviation (no. of months)" name="performanceInd.projectTimelineDeviation.init_proj_comp_date" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="performanceInd.projectTimelineDeviation.const_period" label="Construction duration deviation (%)" name="performanceInd.projectTimelineDeviation.const_period" disabled={true}/>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={12}>
                            <div style={{borderBottom: "3px solid #004494"}}>
                            </div>
                            <Row style={{paddingTop: "15px"}}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="performanceInd.capex" label="CAPEX deviation (%)" name="performanceInd.capex" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="performanceInd.opex" label="OPEX deviation (%)" name="performanceInd.opex" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="performanceInd.maintenance" label="Maintenance cost deviation (%)" name="performanceInd.maintenance" disabled={true}/>
                                </Col>
                                <Col lg={5}>
                                    <TODIS_FORM_FIELD id="performanceInd.ebitda" label="EBITDA – last year (% of projects within user-defined ranges)" name="performanceInd.ebitda" disabled={true}/>
                                </Col>
                                <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                                    <div onClick={() => showModalCalRange("performanceInd.ebitda", "ebitda")}>
                                        <button
                                            className="define-period-button"
                                            style={{
                                                fontSize: '10px', // Tamaño de fuente más pequeño
                                                padding: '0.25rem 0.5rem', // Padding reducido
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                backgroundColor: '#e0e7ff',
                                                border: '2px solid #000080',
                                                borderRadius: '10px', // Bordes redondeados más pequeños
                                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                                color: '#000080',
                                                cursor: 'pointer',
                                                textAlign: 'center',
                                                transition: 'background-color 0.3s, transform 0.3s'
                                            }}
                                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                            onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                            onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                        >
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <span>Define</span>
                                                <span>period</span>
                                                <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                            </div>
                                        </button>
                                    </div>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="performanceInd.revenue" label="Revenue deviation - if fare/toll collected (%)" name="performanceInd.revenue" disabled={true}/>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={12}>
                            <div style={{borderBottom: "3px solid #004494"}}>
                                <Form.Label style={{color: '#004494', fontSize: "16px", fontWeight: "bold"}}>Traffic deviation</Form.Label>
                            </div>
                            <Row style={{paddingTop: "15px"}}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="performanceInd.traffic_dev.total" label="Total traffic deviation (%)" name="performanceInd.traffic_dev.total" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="performanceInd.traffic_dev.pass_cars" label="Passenger cars traffic deviation (%)" name="performanceInd.traffic_dev.pass_cars" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="performanceInd.traffic_dev.busses" label="Bus traffic deviation (%)" name="performanceInd.traffic_dev.busses" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="performanceInd.traffic_dev.hgv" label="HGV traffic deviation (%)" name="performanceInd.traffic_dev.hgv" disabled={true}/>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Tab>
        </Tabs>
    )
}

export default ROADS_IMP_PM_KPI;